<div id="layout" class="sign_in f_col places-page no_max_size">
  <app-view-title class="mb_30" fromRoute="pre-enroll" [chooseLangBtn]="false">{{'places.title' | translate}}</app-view-title>
  <app-table #smartTable *ngIf="config" class="userSmartTable"
  [config]="config"
  [initialConfig]="initialConfig"
  [dataTransformer]="tableDataTransformer"
  [serverItemCount]="totalCount"
  [topButtons]="topButtons"
  (onRowClick)="navigateTo($event.placeId.value)"
  (onQueryChange)="onQueryChange($event)"
  (onLoadingStateChange)="onLoadingStateChange($event)">
  </app-table>
  <div class="btns-container resp_maxSize_l mb_20">
    <app-back-btn icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
  </div>
</div>
